export function initToggleMore() {
    const MAX_HEIGHT = 97; // px
    const COLLAPSE_SELECTOR = '.js-toggle-collapse';
    const TIMELINE_ID = 'communityTimeline';

    function addReadMore(entry) {
console.log(entry);
      /*  if (entry.nextElementSibling?.classList.contains('toggle-more-link') || entry.dataset.collapseInit) return;
        const button = document.createElement('button');
        entry.dataset.collapseInit = 'true';
        button.textContent = 'Mehr anzeigen';
        button.className = 'toggle-more-link link';
        button.addEventListener('click', () => {
            entry.classList.add('active');
            button.remove();
        });
        entry.after(button);*/
        if (!entry.nextElementSibling?.classList.contains('js-open-read-more')) return;
        console.log("init");
        entry.nextElementSibling.addEventListener('click', (e) => {
            entry.classList.add('active');
            entry.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        })

        entry.dataset.hasReadMore = 'true';
    }

    function checkAndInit(entry) {
        if (entry.scrollHeight > MAX_HEIGHT) {
            addReadMore(entry);
        }
    }

    function initCollapse(entry) {
       // if (entry.dataset.collapseInit) return;
   //     entry.dataset.collapseInit = 'true';

        // Initial check
        checkAndInit(entry);

        // Watch for DOM content changes
        const contentObserver = new MutationObserver(() => {
            checkAndInit(entry);
        });
        contentObserver.observe(entry, {
            childList: true,
            subtree: true,
            characterData: true,
        });

        // Watch for size changes (e.g., images loading, fonts rendering)
        const resizeObserver = new ResizeObserver(() => {
            checkAndInit(entry);
        });
        resizeObserver.observe(entry);

        // Extra: check after images load inside the entry
        entry.querySelectorAll('img').forEach(img => {
            if (!img.complete) {
                img.addEventListener('load', () => checkAndInit(entry));
            }
        });
    }

    function initAll() {
        document.querySelectorAll(COLLAPSE_SELECTOR).forEach(initCollapse);
    }

    // Initial pass
    initAll();

    // Watch the whole timeline for new collapse elements
    const timeline = document.getElementById(TIMELINE_ID);
    if (timeline) {
        const timelineObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        if (node.matches(COLLAPSE_SELECTOR)) {
                            initCollapse(node);
                        } else {
                            node.querySelectorAll?.(COLLAPSE_SELECTOR).forEach(initCollapse);
                        }
                    }
                });
            });
        });

        timelineObserver.observe(timeline, {
            childList: true,
            subtree: true
        });
    }
}
